import { startCase, toLower } from 'lodash'
import {
  IntegrationsApi,
  type IResponseMergeField,
  type ISalesforcePropertiesObjectType,
  IntegrationKey,
  type IntegrationsStore,
} from 'entities/Integrations'
import type { IntegrationFieldLoader } from '../types/IntegrationFieldLoader'

export class SalesforceFieldLoader implements IntegrationFieldLoader {
  private readonly objectTypes: ISalesforcePropertiesObjectType[] = ['contact', 'lead']

  constructor(private _integrationsStore: IntegrationsStore) {}

  useGenericApi(): boolean {
    return false // Salesforce needs object-specific endpoints
  }

  async loadAllFields(): Promise<IResponseMergeField[]> {
    const integration = this._integrationsStore.getIntegration(IntegrationKey.salesforce)
    if (!integration?.isConnected) return []

    // Fetch all object types in parallel
    const responses = await Promise.all(
      this.objectTypes.map((objectType) =>
        IntegrationsApi.getSalesforceFieldsByType({ objectType })
      )
    )

    // Keep all fields separate, tag each with its specific object type
    const allFields: IResponseMergeField[] = []

    responses.forEach((response, index) => {
      const objectType = this.objectTypes[index]

      // Add all fields from this object type with the specific object type tag
      response.data.forEach((field) => {
        allFields.push({
          ...field,
          referencedObjectType: startCase(toLower(objectType)), // Tag with specific object type: "Contact" or "Lead"
        })
      })
    })

    return allFields
  }
}
